import * as LJS from "../../../lib/littlejs.esm";
import { tilesize } from '../../const/tiles.ts';
import Globals from "../../globals.ts";
import Actionable from "./actionable.ts";
const lockedTileIndex = 1; // Assuming tile 1 is locked door
const unlockedTileIndex = 3; // Assuming tile 3 is unlocked door
/**
 * LockedDoor entity that requires a key to open. Extends Actionable for interaction.
 */
class LockedDoor extends Actionable {
    constructor(pos) {
        super(pos, lockedTileIndex);
        this.state = "locked";
        this.setCollision(true, true, false, true);
        this.mass = 0; // Not affected by gravity
    }
    /**
     * Override message to show key requirement.
     */
    message() {
        if (this.state === "locked") {
            if (Globals.rexHasKey) {
                LJS.drawTextOverlay("[E] Unlock (Rex has key)", LJS.vec2(this.pos.x, this.pos.y + 1), 0.5);
            }
            else {
                LJS.drawTextOverlay(`[E] Unlock (${Globals.keys} keys)`, LJS.vec2(this.pos.x, this.pos.y + 1), 0.5);
            }
        }
        else {
            LJS.drawTextOverlay("[E] Open", LJS.vec2(this.pos.x, this.pos.y + 1), 0.5);
        }
    }
    /**
     * Action to unlock and open the door if Rex has a key.
     */
    action() {
        console.log("Action triggered on LockedDoor");
        if (this.state === "locked") {
            if (Globals.rexHasKey) {
                Globals.rexHasKey = false;
                this.state = "unlocked";
                this.setCollision(false, false, false, false);
                this.tileInfo = LJS.tile(unlockedTileIndex, tilesize);
                console.log("Door unlocked by Rex.");
            }
            else {
                console.log("Rex does not have a key to unlock door");
            }
        }
        else {
            // If already unlocked, perhaps allow closing or something, but for now just log
            console.log("Door is already unlocked");
        }
    }
}
export default LockedDoor;
